import { useEffect, useState } from "react";
import moment from "moment";
import { Icon } from "@iconify/react";
import { DataGrid } from "@mui/x-data-grid";
import "./IVRMonitoring.css";
import formatSecondsToDuration from "../Helper/formatSecondsToDuration";
import { ReactComponent as IVRMonitoringIcon } from "../Images/IVRMonitoringIcon.svg";
import { getIVRMonitoring } from "../Store/Actions/MonitoringAction";

const IVRMonitoring = ({ IVRDeviceID }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = () => {
      getIVRMonitoring(IVRDeviceID)
        .then((response) => {
          if (response.status) {
            console.log("IVR monitoring data: ", response.data);
            setData(response.data);
          } else {
            console.log("error", response.error);
          }

          setIsLoading(false);
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every one second
    const interval = setInterval(() => {
      fetchData();
    }, 1000);

    return () => clearInterval(interval);
  }, [IVRDeviceID]);

  const columns = [
    {
      align: "center",
      // field: "id",
      flex: 1,
      headerAlign: "center",
      headerName: "No",
      maxWidth: 50,

      renderCell: (params) => {
        return params.api.getRowIndex(params.row) + 2;
      },
    },

    {
      field: "CallerNo",
      flex: 1,
      headerName: "Phone No",
    },

    {
      field: "CallTime",
      flex: 1,
      headerName: "Call Time",

      renderCell: (params) =>
        moment.utc(params.row.CallTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "CallState",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "menu",
      flex: 1,
      headerName: "Menu",
    },

    {
      field: "TotalDuration",
      flex: 1,
      headerName: "Duration",
      renderCell: (params) => formatSecondsToDuration(params.row.TotalDuration),
    },
  ];

  return (
    <div className="ivr-monitoring">
      <div className="item total-calls">
        <Icon
          className="icon"
          height="40"
          icon="material-symbols:call-log"
          width="40"
        />

        <div>
          <p className="title">Total calls</p>

          <p className="value">
            {isLoading
              ? "Loading..."
              : data.ivrsummary
              ? data.ivrsummary[0]?.TotalCalls
              : 0}
          </p>
        </div>
      </div>

      <div className="item calls-delivered">
        <Icon
          className="icon"
          height="40"
          icon="carbon:router-voice"
          width="40"
        />

        <div>
          <p className="title">Calls delivered to acd</p>

          <p className="value">
            {isLoading
              ? "Loading..."
              : data.ivrsummary
              ? data.ivrsummary[0]?.TotalCallDeliveredACD
              : 0}
          </p>
        </div>
      </div>

      <div className="item active-calls">
        <IVRMonitoringIcon
          className="icon"
          fill="#FFF"
          height="40"
          width="40"
        />

        <div>
          <p className="title">Active ivr calls</p>

          <p className="value">
            {isLoading
              ? "Loading..."
              : data.ivrdetail
              ? data.ivrdetail.reduce(
                  (count, obj) =>
                    obj.CallState === "CONNECTED" ? ++count : count,
                  0
                )
              : 0}
          </p>
        </div>
      </div>

      <div className="item active-calls-detail">
        <div className="title">
          <IVRMonitoringIcon className="icon" height="26" width="26" />
          Active IVR Calls Detail
        </div>

        <DataGrid
          autoHeight
          className="table"
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableSelectionOnClick
          hideFooter
          loading={isLoading}
          rows={data.ivrdetail ? data.ivrdetail : []}
          getRowId={() => Math.random()}
        />
      </div>
    </div>
  );
};

export default IVRMonitoring;
